export default ({ request }) => ({
  ecomAmzSkuListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuPutShelvesApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/putShelves',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuFollowSaleApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/followSale',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuCrossSiteSalesApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/crossSiteSales',
      method: 'POST',
      data,
    })
  },
  //  产品图片
  ecomAmzSkuImageListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/image/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuImageUploadApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/image/upload',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuImageSetDefaultApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/image/setDefault',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuImageDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/image/del',
      method: 'POST',
      data,
    })
  },
  //  产品包装图片
  ecomAmzSkuImagePackageListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/image/package/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuImagePackageUploadApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/image/package/upload',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuImagePackageDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/image/package/del',
      method: 'POST',
      data,
    })
  },
  // 产品销售店铺
  ecomAmzSkuStoreListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/store/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuStoreListByOnSaleApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/store/listByOnSale',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuStoreDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/store/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuStoreUnsaleableApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/store/unsaleable',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuStoreAvailableSaleApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/store/availableSale',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuStoreRestockingApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/store/restocking',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuStoreUnrestockingApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/store/unrestocking',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuStoreDisableDisplayApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/store/disableDisplay',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuStoreSetOperateApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/store/setOperate',
      method: 'POST',
      data,
    })
  },
  // Listing
  ecomAmzSkuListingApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/listing',
      method: 'POST',
      data,
    })
  },
  //生产厂家
  ecomAmzSkuFtyListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/fty/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuFtyDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/fty/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuFtySaveApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/fty/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuFtyDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/fty/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuFtyMatchNoResultReturnDefaultApi(params = {}) {
    return request({
      url: '/ecom/amz/sku/fty/matchNoResultReturnDefault',
      method: 'GET',
      params,
    })
  },
  ecomAmzSkuListBySpuCodeApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/listBySpuCode',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuDetailPrintViewApi(params = {}) {
    return request({
      url: '/ecom/amz/sku/print/detail',
      method: 'GET',
      params,
    })
  },
  ecomAmzSkuCopyApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/copy/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuFtyScmNcNoApi(params = {}) {
    return request({
      url: '/ecom/amz/sku/fty/scm/ncNo',
      method: 'GET',
      params,
    })
  },
  ecomAmzSkuListingDetailViewApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/listing/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuListingSaveViewApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/listing/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuChangeDesignApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/changeDesign',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuFtyPrintScmListApi(params = {}) {
    return request({
      url: '/ecom/amz/sku/fty/print/scm/list',
      method: 'GET',
      params,
    })
  },
  ecomAmzSkuPurchasableApplyApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/purchasable/apply',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuPurchasableApprovedApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/purchasable/approved',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuReturnApplicationApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/returnApplication',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuPurchasableRejectApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/purchasable/reject',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuFullMemberApplyApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/fullMember/apply',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuInformationApplyApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/information/apply',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuInformationApprovedApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/information/approved',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuInformationRejectApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/information/reject',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuFullMemberApprovedApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/fullMember/approved',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuFullMemberRejectApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/fullMember/reject',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuPlaceListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/place/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecSizeSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/size',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuUpdateSizeSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/update/size',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecCustomsApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/customs',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuMaterialInfoSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/info',
      method: 'POST',
      data,
    })
  },
  masterGoodsInputStandardCategoryDetailApi(data = {}) {
    return request({
      url: '/master/goods/input/standard/category/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSampleListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/sampleList',
      method: 'POST',
      data,
    })
  },
  ecomAmzModiDefaultFactoryPriceApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/fty/modiDefaultFactoryPrice',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecFabricChooseFabricListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/fabric/choose/fabric/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecFabricListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/fabric/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecFabricSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/fabric/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecFabricDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/fabric/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecFabricSaveBatchApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/fabric/save/batch',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecFabricEditSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/fabric/edit/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecFabricDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/fabric/del',
      method: 'POST',
      data,
    })
  },

  ecomAmzSkuMaterialListApi(data = {}) {
    return request({
      url: '/ecom/ecomAmzSkuMaterial/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecMaterialListApi(data = {}) {
    return request({
      url: '/ecom/ecomAmzSkuSpecMaterial/list',
      method: 'POST',
      data,
    })
  },

  ecomAmzSkuMaterialImageListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/image/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuMaterialDetailApi(data = {}) {
    return request({
      url: '/ecom/ecomAmzSkuMaterial/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuMaterialImageSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/image/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuMaterialSaveApi(data = {}) {
    return request({
      url: '/ecom/ecomAmzSkuMaterial/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuMaterialDelApi(data = {}) {
    return request({
      url: '/ecom/ecomAmzSkuMaterial/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuMaterialMaterialApi(data = {}) {
    return request({
      url: '/ecom/ecomEvgSkuMaterial/material',
      method: 'POST',
      data,
    })
  },

  ecomAmzSkuMaterialImageDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/image/del',
      method: 'POST',
      data,
    })
  },

  ecomAmzSkuMaterialImageUpdateSortOrderApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/image/updateSortOrder',
      method: 'POST',
      data,
    })
  },
})
